{
    "name": "frontend-app",
    "version": "0.1.1",
    "private": true,
    "type": "module",
    "dependencies": {
        "@configcat/sdk": "1.1.0",
        "@formatjs/intl": "4.1.20",
        "@reduxjs/toolkit": "2.12.0",
        "@rio-cloud/iframe-resizer": "1.1.2",
        "@rio-cloud/rio-notifications-component": "2.0.0-beta.1",
        "@rio-cloud/rio-order-chat-component": "0.6.3",
        "@rio-cloud/rio-session-expired-info": "2.0.0",
        "@rio-cloud/rio-uikit": "3.0.0",
        "@rio-cloud/rio-user-menu-component": "5.0.0-beta.2",
        "@sentry/browser": "10.73.0",
        "@stripe/react-stripe-js": "5.6.1",
        "@stripe/stripe-js": "8.11.0",
        "classnames": "2.5.1",
        "configcat-react": "5.1.0",
        "cssuseragent": "2.1.31",
        "date-fns": "4.4.0",
        "es-toolkit": "1.52.0",
        "file-saver": "2.0.5",
        "fp-ts": "2.16.11",
        "hoist-non-react-statics": "3.3.2",
        "io-ts": "2.2.22",
        "jwt-decode": "4.0.0",
        "oidc-client-ts": "3.5.0",
        "prop-types": "15.8.1",
        "qs": "6.16.0",
        "react": "19.2.8",
        "react-confetti-explosion": "3.0.3",
        "react-dom": "19.2.8",
        "react-intl": "10.1.26",
        "react-redux": "9.3.0",
        "react-router": "8.3.1",
        "react-slick": "0.31.0",
        "reselect": "5.3.0",
        "slick-carousel": "1.8.1"
    },
    "scripts": {
        "start": "concurrently --kill-others \"npm run dev-mock-server\" \"vite\"",
        "start-with-environment": "docker-compose up -d authorizationserver-for-login && npm run start",
        "build": "vite build",
        "dependency-cruiser": "depcruise --validate .dependency-cruiser.cjs src",
        "test": "vitest --reporter=default",
        "test-ci": "tsc && vitest run --reporter=default --reporter=junit --outputFile=./results/junit.xml",
        "test-dev": "vitest --ui",
        "coverage": "vitest run --coverage",
        "audit": "npm audit --registry https://registry.npmjs.org --audit-level \"moderate\" --parseable --omit=dev",
        "pretest": "tsc",
        "ci-install": "PUPPETEER_SKIP_CHROMIUM_DOWNLOAD=true npm install",
        "dev-mock-server": "nodenv mocks/rio-starter-devmocks.cjs --exec nodemon",
        "lint": "biome check .",
        "lint-fix": "npm run lint -- --write",
        "lint-fix-unsafe": "npm run lint-fix -- --unsafe",
        "format-code": "biome format --write .",
        "pull-translations": "phrase pull --access_token $PHRASEAPP_ACCESS_TOKEN && npm run merge-translations",
        "push-translations": "npm run split-translations && phrase push --access_token $PHRASEAPP_ACCESS_TOKEN && rm -rf src/features/app/lang/locales/temp",
        "push-translations-marketplace": "npm run split-translations && phrase push --access_token $PHRASEAPP_ACCESS_TOKEN --config .phrase.marketplace.yml && rm -rf src/features/app/lang/locales/temp",
        "merge-translations": "nodenv ./mergeTranslations.js && rm -rf src/features/app/lang/locales/temp",
        "split-translations": "nodenv ./splitTranslations.js",
        "postinstall": "if [ \"$CI\" != \"true\" ]; then pre-commit install; fi"
    },
    "browserslist": [
        "last 2 versions",
        "last 5 Chrome versions",
        "Firefox >= 90",
        "Edge >= 95",
        "Safari >= 14"
    ],
    "devDependencies": {
        "@biomejs/biome": "2.5.12",
        "@rio-cloud/biome-config": "2.0.0",
        "@testing-library/dom": "10.4.1",
        "@testing-library/jest-dom": "7.0.1",
        "@testing-library/react": "16.3.3",
        "@testing-library/user-event": "14.6.7",
        "@types/classnames": "2.3.4",
        "@types/file-saver": "2.0.7",
        "@types/hoist-non-react-statics": "3.3.7",
        "@types/node": "26.5.0",
        "@types/qs": "6.15.1",
        "@types/react": "19.2.18",
        "@types/react-dom": "19.2.7",
        "@types/react-slick": "0.23.13",
        "@types/redux-mock-store": "1.5.0",
        "@types/sinon": "22.0.0",
        "@vitejs/plugin-react": "5.2.0",
        "@vitest/coverage-v8": "5.0.0",
        "@vitest/ui": "5.0.0",
        "concurrently": "10.0.5",
        "cors": "2.8.6",
        "dependency-cruiser": "18.2.0",
        "express": "5.2.1",
        "http-proxy-middleware": "4.2.0",
        "happy-dom": "20.14.0",
        "license-checker": "25.0.1",
        "node-env-run": "4.0.2",
        "node-fetch": "3.3.2",
        "nodemon": "3.1.14",
        "rollup-plugin-visualizer": "7.1.1",
        "serialize-javascript": "7.1.1",
        "sinon": "22.1.0",
        "typescript": "5.9.3",
        "vite": "8.2.2",
        "vitest": "5.0.0",
        "vitest-fetch-mock": "0.4.5"
    },
    "engines": {
        "node": ">=24.x",
        "npm": ">=11"
    }
}
